import { produce, Draft } from 'immer'
import { FETCH_CITIES_REQUEST, SET_CITIES_DATA } from './types'

import { fetchCitiesRequest, setCitiesData } from './actions'

import { AreaGroupedCities } from './models'

const initialState = {
  data: { result: [], entities: {} },
}

export type CitiesState = Readonly<{
  data: {
    result: AreaGroupedCities[]
  }
}>

export const CitiesReducer = produce(
  (
    draft: Draft<CitiesState>,
    action: ReturnType<typeof fetchCitiesRequest> | ReturnType<typeof setCitiesData>
  ) => {
    switch (action.type) {
      case FETCH_CITIES_REQUEST:
        draft
        break
      case SET_CITIES_DATA:
        draft.data.result = action.payload.cities.result
        break
      default:
        draft
    }
  },
  initialState
)
